// The one definition of "which app is this request for".
//
// Every app-scoped route lives under /apps/:appId/. Callers pass { appId }
// explicitly (from useParams or props); resolveAppId falls back to sniffing
// /apps/:appId/ from the pathname ONLY as a safety net for call sites missed
// by a migration — the dev-mode warning below is the tripwire.
//
// Extracted from workflowApi.js so screensApi.js's form-screen and grid-layout
// helpers share it rather than growing a second copy that can drift.
export const resolveAppId = (appId) => {
  if (appId !== undefined && appId !== null && appId !== "") return appId;
  const m = typeof window === "undefined" ? null : window.location.pathname.match(/\/apps\/(\d+)/);
  const sniffed = m ? m[1] : "";
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.warn(`resolveAppId: appId not passed explicitly; sniffed "${sniffed}" from URL`);
  }
  return sniffed;
};
